export Enum              from './Enum'
export ApiUtils          from './ApiUtils'
export ChargeUtils       from './ChargeUtils'
export AnalyticsUtils    from './AnalyticsUtils'
export NpsUtils          from './NpsUtils'
export TemplateUtils     from './TemplateUtils'
export hotjar            from './hotjar'
export GlobalErrorUtils  from './GlobalErrorUtils'
export CheckUtils        from './CheckUtils'
export * as Functions      from './Functions'



// WEBPACK FOOTER //
// ./app/utils/index.js